interface ListDisplayProps {
  initialList: number[] | string[];
  alternativeValue: string;
}

function ListDisplay({ initialList, alternativeValue }: ListDisplayProps) {
  return (
    <>
      <div
        style={{
          borderRadius: "0.3em",
          overflowY: "auto",
          overflowX: "hidden",
          maxHeight: "250px",
          maxWidth: "100%",
        }}
      >
        {initialList.length > 0
          ? initialList.map((x) => (
              <div
                key={x}
                style={{
                  marginBottom: "3px",
                  marginLeft: "3px",
                  display: "inline-block",
                  width: "fit-content",
                  wordWrap: "break-word",
                  overflowWrap: "break-word",
                  border: "1px solid lightgrey",
                  padding: "3px",
                  textAlign: "center",
                  borderRadius: "0.3em",
                }}
              >
                {x}
              </div>
            ))
          : null}
      </div>
    </>
  );
}

export default ListDisplay;
